import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeCustomDialogAction, openCustomDialog } from '../../../redux/slices/customDialogSlice';
import MicroFront from '../MicroFront';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    mf: {
        padding: theme.spacing(0, 3, 3, 3),
    },
    paper: {
        height: '75vh',
        width: 620,
    }
}));

const EditLeadAction = ({ payload, onComplete }) => {
    const { classes } = useStyles();
    
    const dispatch = useDispatch();

    const { t } = useTranslation();
    
    useEffect(() => {
        const onClose = (result) => {
            try {
                onComplete?.(result || null);
            } catch (e) {
                console.error('Error calling edit contact complete callback', e);
            }
            dispatch(closeCustomDialogAction());
        };
        
        dispatch(
            openCustomDialog(MicroFront, {
                contentProperties: {
                    slug: 'lead',
                    path: 'edit',
                    className: classes.mf,
                    data: payload,
                    onDialogClose: onClose,
                    skipLoader: true,
                },
                paperClass: classes.paper,
                onClose,
                beforeClose: onClose,
                title: t(payload?.id ? 'contact.form.editContact' : 'contact.form.newContact'),
            })
        );
        // eslint-disable-next-line
    }, []);
};

export default EditLeadAction;
